export default function createEntityIllustration(image: string, icon?: string) {
    return icon ? { image: image, icon: icon } : { image: image };
}
